(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-carousel-peek')) {
    customElements.define('collection-carousel-peek', class extends HTMLElement {
      async connectedCallback() {
        if (this.dataset.enabled !== 'true') return;
        const connection = {};
        this.connection = connection;
        await customElements.whenDefined('carousel-slider');
        if (!this.isConnected || this.connection !== connection) return;

        const carousel = this.querySelector('carousel-slider');
        if (!carousel) return;
        this.carousel = carousel;
        this.originalInit = carousel.initSlider;
        this.originalVisibility = carousel.getSlideVisibility;
        const mobile = window.matchMedia('(max-width: 767.98px)');

        // Keep the theme's navigation, dragging, quick buy, and editor hooks.
        // Only this section instance uses centered visibility on phones.
        carousel.getSlideVisibility = (slide) => {
          if (!mobile.matches) return this.originalVisibility.call(carousel, slide);
          const viewport = carousel.slider.getBoundingClientRect();
          const card = slide.getBoundingClientRect();
          return card.left >= viewport.left - 1 && card.right <= viewport.right + 1;
        };

        carousel.initSlider = () => {
          const previousIndex = Math.abs(carousel.currentIndex || 0);
          this.originalInit.call(carousel);
          if (!mobile.matches || !carousel.slideSpan) return;

          // Start on the second product to show a real neighbor on both sides.
          // Subsequent refreshes preserve the shopper's position.
          const index = !this.startedOnMobile && carousel.slides.length > 2
            ? 1 : Math.min(previousIndex, carousel.slides.length - 1);
          this.startedOnMobile = true;
          carousel.slider.scrollTo({
            left: index * carousel.slideSpan * (carousel.rtl ? -1 : 1),
            behavior: 'instant'
          });
          carousel.currentIndex = index;
          if (carousel.nav) carousel.setButtonStates();
        };

        if (carousel.slides.length > 1) carousel.refresh();
      }

      disconnectedCallback() {
        this.connection = null;
        if (!this.carousel) return;
        const carousel = this.carousel;
        if (carousel.hasAttribute('loaded')) {
          carousel.removeListeners();
          carousel.removeAttribute('loaded');
        }
        carousel.initSlider = this.originalInit;
        carousel.getSlideVisibility = this.originalVisibility;
        this.carousel = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
